import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {Contact, Contacts} from "./types";
import {PathProps} from "../../index";

export function onManageContact(path: PathProps, contact: Contact) {
  path.navigate("/contact/" + contact.id);
}

export class EditContactHelper {

  static addContact() {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditContactFragment onContactSaved={contact => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editContact(contact: Contact) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditContactFragment edit={contact} onContactSaved={contact => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditContactFragmentProps = PageFragmentProps & {
  edit?: Contact,
  onContactSaved: (contact: Contact) => void,
}

class EditContactFragment extends DialogFragment<EditContactFragmentProps> {

  private readonly contacts = Contacts.getInstance();
  private readonly contact = this.props.edit ? this.props.edit : Contact.createNew();

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit" : "Add",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.addContact().then(() => this.props.onContactSaved(this.contact));
  }

  private async addContact() {
    await this.contacts.addListItem(this.contact);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: DW_LG}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.contact}
        saveActionButtonProvider={this}/>
    </Box>;
  }
}
